import React, {Component} from "react"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"
import {Col, FormGroup, FormControl, InputGroup} from "react-bootstrap"

import {InjectIntl, injectIntl, FormattedMessage} from "@irati/utils/lang"
import {ValidationInput} from "@irati/utils/validation"

import Button, {IconTypes} from "../Button"
import ErrorText from "../ErrorText"
import IconText from "../IconText"

interface Props extends InjectIntl {
  type?: string
  name?: string
  label?: string
  hintText?: string
  maxFiles?: number
  file?: {name: string}
  onChange: () => void
}

interface State {
  errorMsg: string | null
  value: string
}

interface Context {
  currentScreen?: string
}

class File extends Component<Props, State> {
  validation: ValidationInput

  static contextTypes = {
    currentScreen: PropTypes.string
  }

  static defaultProps: Omit<Props, "intl" | "formatMessage" | "onChange"> = {
    type: "text",
    hintText: "admin.components.samlSingleSignOn.file.hintText",
    maxFiles: 1
  }

  constructor(props: Props, context: Context) {
    super(props, context)

    this.state = {
      errorMsg: null,
      value: props.file?.name || ""
    }

    this.validation = new ValidationInput(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (nextProps.file) {
      this.setState({value: nextProps.file.name})
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    this.validation.update(prevProps, prevState)
  }

  componentWillUnmount() {
    this.validation.destroy()
  }

  render() {
    const {hintText, maxFiles, name, formatMessage, label, onChange, type} = this.props
    const {errorMsg, value} = this.state

    return (
      <FormGroup controlId={name}>
        <Col sm={12}>{label}</Col>
        <Dropzone name="file" accept={type} maxFiles={maxFiles} className={`dropzone-${name}`} onClick={onChange} onDrop={onChange}>
          <Col sm={12}>
            <InputGroup>
              <FormControl disabled type="text" value={value} />
              <InputGroup.Button>
                <Button marginLeft={2} onClick={onChange}>
                  <FormattedMessage id="admin.components.samlSingleSignOn.file.button.chooseFile" />
                </Button>
              </InputGroup.Button>
            </InputGroup>
          </Col>
          <Col sm={12}>
            <div>
              <IconText icon={IconTypes.info} small>
                {formatMessage({id: hintText})}
              </IconText>
            </div>
          </Col>
        </Dropzone>
        {errorMsg && (
          <Col sm={12}>
            <ErrorText small>{errorMsg}</ErrorText>
          </Col>
        )}
      </FormGroup>
    )
  }
}

export default injectIntl(File)
